import { render, staticRenderFns } from "./GlobalNewsEdit.vue?vue&type=template&id=5b6c5e41&scoped=true"
import script from "./GlobalNewsEdit.vue?vue&type=script&lang=js"
export * from "./GlobalNewsEdit.vue?vue&type=script&lang=js"
import style0 from "./GlobalNewsEdit.vue?vue&type=style&index=0&id=5b6c5e41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6c5e41",
  null
  
)

export default component.exports